/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button, ButtonGroup } from "@mui/material";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const UpDownButtons = (props) => {
    const { handleUp, handleDown, upDisabled = false, downDisabled = false } = props;
    // const classes = useStyles()
    const ariaLabelUp = upDisabled ? "can not move up" : "move up";
    const ariaLabelDown = downDisabled ? "can not move down" : "move down";

    return (
        <div className='question-positionButtonsContainer'>
            <div className='question-positionButtons'>
                <ButtonGroup orientation='vertical'>
                    <Button
                        key='up'
                        color='neutral'
                        disabled={upDisabled}
                        onClick={handleUp}
                        aria-label={ariaLabelUp}
                        className='question-positionButton'
                    >
                        <KeyboardArrowUpOutlinedIcon />
                    </Button>
                    <Button
                        key='down'
                        color='neutral'
                        disabled={downDisabled}
                        onClick={handleDown}
                        aria-label={ariaLabelDown}
                        className='question-positionButton'
                    >
                        <KeyboardArrowDownOutlinedIcon />
                    </Button>
                </ButtonGroup>
            </div>
        </div>
    );
};
export default UpDownButtons;
